import React, { FC } from 'react'
import { Alert, Button, Row } from 'antd'
import { InfoCircleFilled } from '@ant-design/icons'
import { SchedulerSmsControlProps } from './types'

const SchedulerSmsControl: FC<SchedulerSmsControlProps> = ({
  notaryAcknowledgement,
  smsRemindersPaused,
  pausingReminders,
  onPause
}) => {
  if (notaryAcknowledgement || smsRemindersPaused) return null

  return (
    <Alert
      type="warning"
      icon={<InfoCircleFilled />}
      showIcon
      style={{ marginBottom: 16 }}
      message="Notary has not acknowledged errors yet"
      description={
        <Row justify="space-between" align="middle" gutter={[0, 8]}>
          <span>If you are already in contact with the notary about the errors, you may pause SMS reminders.</span>
          <Button loading={pausingReminders} onClick={onPause}>
            Pause reminders
          </Button>
        </Row>
      }
    />
  )
}

export default SchedulerSmsControl
